// fx.js — ported component effects for the storefront
// Flowing background paths (#contacto). Hero pills + ethereal shadow are pure CSS/SVG.
(function () {
  var SVGNS = "http://www.w3.org/2000/svg";
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function pathD(i, position) {
    return "M-" + (380 - i * 5 * position) + " -" + (189 + i * 6) +
      "C-" + (380 - i * 5 * position) + " -" + (189 + i * 6) +
      " -" + (312 - i * 5 * position) + " " + (216 - i * 6) +
      " " + (152 - i * 5 * position) + " " + (343 - i * 6) +
      "C" + (616 - i * 5 * position) + " " + (470 - i * 6) +
      " " + (684 - i * 5 * position) + " " + (875 - i * 6) +
      " " + (684 - i * 5 * position) + " " + (875 - i * 6);
  }

  function buildPaths() {
    var host = document.querySelector("[data-paths]");
    if (!host || host.dataset.built) return;
    host.dataset.built = "1";
    [1, -1].forEach(function (position) {
      var svg = document.createElementNS(SVGNS, "svg");
      svg.setAttribute("viewBox", "0 0 696 316");
      svg.setAttribute("fill", "none");
      svg.setAttribute("preserveAspectRatio", "xMidYMid slice");
      for (var i = 0; i < 36; i++) {
        var p = document.createElementNS(SVGNS, "path");
        p.setAttribute("d", pathD(i, position));
        p.setAttribute("pathLength", "1");
        p.setAttribute("stroke-width", (0.5 + i * 0.06).toFixed(2));
        p.style.opacity = (0.1 + i * 0.022).toFixed(3);
        if (!reduce) {
          p.style.strokeDasharray = "0.35 0.65";
          p.style.animation = "pathflow " + (20 + Math.random() * 12).toFixed(1) + "s linear infinite";
          p.style.animationDelay = (-Math.random() * 20).toFixed(1) + "s";
        }
        svg.appendChild(p);
      }
      host.appendChild(svg);
    });
  }

  function init() { buildPaths(); }
  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
